import React from "react";
import ProductSingleCard from "./ProductSingleCard";

const ProductCard = ({ product, isPublicView, onSelectImage }) => {
  return (
    <div className="grid sm:grid-cols-2 lg:grid-cols-3 max-w-[1200px] gap-6 mx-auto place-items-center">
      {Array.isArray(product) &&
        product.map((item, index) => (
          <ProductSingleCard
            key={item._id || index}
            product={item}
            index={index}
            isPublicView={isPublicView}
            onSelectImage={onSelectImage}
          />
        ))}
    </div>
  );
};

export default ProductCard;
